/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs */

const en_directory_agent_readiness_dimension_execution_verifiability = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execution verifiability`)
};

const zh_directory_agent_readiness_dimension_execution_verifiability = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`执行结果可验证性`)
};

/**
* | output |
* | --- |
* | "Execution verifiability" |
*
* @param {Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_execution_verifiability = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Execution_VerifiabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_execution_verifiability(inputs)
	return zh_directory_agent_readiness_dimension_execution_verifiability(inputs)
});
export { directory_agent_readiness_dimension_execution_verifiability as "directory.agent_readiness.dimension.execution_verifiability" }